import React from 'react'

import Navigation from './components/Navigation'
import Registration from './components/Registration'
import LoadPropertyType from './components/steps/LoanPropertyType'
import LoanPurpose from './components/steps/LoanPurpose'
import RefinanceReason from './components/steps/RefinanceReason'
import HasFoundHome from './components/steps/HasFoundHome'
import LoanTarget from './components/steps/LoanTarget'
import LoanLocation from './components/steps/LoanLocation'
import CashOutReason from './components/steps/CashOutReason'
import { sendSlackNotification } from './api'

import { registrationRequest } from './api'

// DATA STRUCTURE
// loanPurpose: [ refinance, purchase ]
// loanTarget: [ own_home, investment ]
// refinanceReason: [ better_deal, consolidate_debt, cash_out]
// has_found_home: [ true, false ]
class App extends React.Component {
  state = {
    step: 1,
    loanPurpose: null,
    refinanceReason: null,
    hasFoundHome: null,
    loanTarget: null,
    loanPropertyType: null,
    locationAddress: null,
    locationSuburb: null,
    locationPostcode: null,
    locationState: null,
    spendAmount: null,
    loanAmount: null,
    rentAmount: null,
    loanRatio: null,
    userName: null,
    userEmail: null,
    registrationErrors: {},
    cashOutSelected: null,
    cashOutReason: null,
    cashOutAmount: null
  };


  componentDidMount() {
    if (gon.onboarding_funnel.loanPurpose) {
      this.setState({
        loanPurpose: gon.onboarding_funnel.loanPurpose,
        loanTarget: gon.onboarding_funnel.loanTarget,
        loanAmount: gon.onboarding_funnel.loanAmount,
        step: 2 //TODO: This must be the new 4
      })
    }
  }

  onChoice = (data) => {
    if (data.refinanceReason !== 'cash_out') {
      let nextStep = this.state.step + 1;
      this.setState({ ...this.state, cashOutSelected: false, step: nextStep, ...data })
    } else {
      this.setState({ ...this.state, cashOutSelected: true, ...data })
    }
  };

  onGoBack = () => {
    let prevStep = this.state.step - 1;
    this.setState({ ...this.state, step: prevStep, cashOutSelected: !!this.state.cashOutReason});
    if (prevStep === 4) {
      if (this.state.cashOutReason && this.state.refinanceReason !== 'cash_out') {
        this.setState({ cashOutSelected: false, cashOutReason: null, cashOutAmount: null })
      }
      this.setState({ loanAmount: null })
    }
  };

  backToRefinanceStep = () => {
    this.setState({ ...this.state, cashOutSelected: false})
  };

  onRegistrationSuccess = ({data}) => {
    const {host, protocol} = location;
    const {redirectTo} = data;
    window.location.assign(`${protocol}//${host}${redirectTo}`);
  };

  onRegistrationFailure = ({ response }) => {
    let errors = response.data.errors;

    if ( errors.hasOwnProperty('userEmail') ) {
      this.setState({ registrationErrors: errors })
    } else {
      let swalTitle = I18n.t('onboarding.generic_error.title');
      let swalText = I18n.t('onboarding.generic_error.description');

      if ((response.status) === 422) {
        swalTitle = I18n.t('onboarding.generic_error.title');
        swalText = Object.values(response.data.errors)[0]
      }

      swal({
         title: swalTitle,
         text: swalText,
         type: 'warning',
         showCancelButton: false,
         confirmButtonText: 'Retry',
         allowOutsideClick: false,
         confirmButtonColor: '#10c98f',
      }).then(() => {
        window.location.reload()
      })
    }
  };

  onRegistrationSubmit = (user) => {
    let {hasFoundHome, loanPurpose} = this.state;
    if (hasFoundHome == null && loanPurpose === 'refinance')
      this.state.hasFoundHome = true;
    let data = {
      onboardingFunnel: {
        ...this.state,
        ...user
      }
    };

    registrationRequest(data,
                        this.onRegistrationSuccess,
                        this.onRegistrationFailure,
                        )
  };

  renderStep () {
    let stepComponent = null;

    switch(this.state.step) {
      case 1:
        stepComponent = <LoanPurpose onChoice={ this.onChoice } />;
        break;
      case 2:
        stepComponent = <LoanTarget onChoice={ this.onChoice }
                                    onGoBack={ this.onGoBack }
                                    loanPurpose={ this.state.loanPurpose } />;
        break;
      case 3:
        stepComponent = <LoadPropertyType onChoice={ this.onChoice }
                                          onGoBack={ this.onGoBack }
                                          loanPurpose={ this.state.loanPurpose } />;
        break;
      case 4:
        if (this.state.loanPurpose === 'refinance' && !this.state.cashOutSelected) {
          stepComponent = <RefinanceReason onChoice={ this.onChoice }
                                           onGoBack={ this.onGoBack }
                                           loanTarget={ this.state.loanTarget } />
        } else if (this.state.loanPurpose === 'refinance' && this.state.cashOutSelected) {
          stepComponent = <CashOutReason  onChoice={ this.onChoice }
                                          onGoBack={ this.backToRefinanceStep }
                                          cashOutReason={ this.state.cashOutReason }
                                          cashOutAmount={ this.state.cashOutAmount }/>
        } else {
          stepComponent = <HasFoundHome onChoice={ this.onChoice }
                                        onGoBack={ this.onGoBack }
                                        loanTarget={ this.state.loanTarget } />
        }
        break;
      case 5:
        stepComponent = <LoanLocation onChoice={ this.onChoice }
                                      onGoBack={ this.onGoBack }
                                      loanAmount= { this.state.loanAmount }
                                      loanPurpose={ this.state.loanPurpose }
                                      loanTarget={ this.state.loanTarget }
                                      registrationErrors={ this.state.registrationErrors }
                                      hasFoundHome={ this.state.hasFoundHome } />;
        break;
      case 6:
        stepComponent = <Registration loanApplication={ this.state }
                                      onGoBack={ this.onGoBack }
                                      onRegistrationSubmit={ this.onRegistrationSubmit }
                                      registrationErrors={ this.state.registrationErrors } />;
        break
    }

    return(
      <div>
        { stepComponent }
      </div>
    )
  }

  render() {
    let { step } = this.state;

    return (
      <div id='main'>
        <Navigation step={ step }/>
        { this.renderStep() }
      </div>
    )
  }
}

export default App
